<template>
  <div class="about-view">
    <v-card class="mx-auto" max-width="400">
      <v-card-title>
        <span class="mr-2">
          Clientes Loyall
        </span>

        <v-chip outlined small color="primary">
          {{ appVersion }}
        </v-chip>
      </v-card-title>

      <v-card-subtitle>
        Frontend application
      </v-card-subtitle>

      <v-list two-line>
        <template v-for="item of appInfo">
          <v-list-item :key="item.title">
            <v-list-item-icon v-if="item.icon">
              <v-icon v-text="item.icon" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>

              <v-list-item-subtitle>
                {{ item.content }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import config from '@/config';

export default {
  name: 'AboutView',

  data: () => ({
    appVersion: config.VUE_APP_VERSION,
    buildMode: config.NODE_ENV,
    deployTarget: config.VUE_APP_DEPLOY_TARGET,
  }),

  computed: {
    appInfo: (vm) => [
      {
        icon: 'mdi-wrench-outline',
        title: 'Build mode',
        content: vm.buildMode,
      },

      {
        icon: 'mdi-package-variant-closed',
        title: 'Deploy target',
        content: vm.deployTarget,
      },
    ],
  },
};
</script>
